<div class="payment-register-container">
  <div class="form payment-register-form">
    <div>
      <img src="/assets/img/logo.svg" alt="Gamelearn" class="logo" />
    </div>

    <div *ngIf="processing" class="payment-card">
      <form>
        <h1 class="h1">{{ 'payment.paymentData' | translate }}</h1>

        <div class="form-row">
          <label [attr.for]="payment.clientMail">{{ 'payment.amount' | translate }}</label>
          <div class="info">
            {{ payment.amount | number : '1.2-2' : locale }}
            <span *ngIf="payment.currency" class="info gap">{{ payment.currency }}</span>
          </div>
        </div>

        <div class="form-row">
          <label [attr.for]="payment.clientMail">{{ 'payment.invoiceNumber' | translate }}</label>
          <div class="info dark">{{ payment.invoiceNumber }}</div>
        </div>

        <div class="form-column">
          <label [attr.for]="payment.clientMail" class="label-text">{{
            'actions.email' | translate
          }}</label>
          <input
            #clientMail="ngModel"
            id="clientMail"
            name="clientMail"
            placeholder="{{ 'actions.emailPlaceholder' | translate }}"
            class="input"
            [(ngModel)]="payment.clientMail"
            type="email"
            email
            required
          />
        </div>

        <div class="grid-cards">
          <div class="grid-cards__title">
            {{ 'actions.cardData' | translate }}
          </div>
          <div class="grid-cards__items">
            <img alt="" width="38" src="assets/img/logo-visa.svg" />
            <img alt="" width="38" src="assets/img/logo-mastercard.svg" />
            <img alt="" width="38" src="assets/img/logo-american-express.svg" />
          </div>
        </div>
        <div class="grid-cards__fields">
          <div class="grid-cards__fields--item">
            <label class="label" for="card-number">{{ 'nouns.cardNumber' | translate }}</label>
            <div id="card-number" class="input"></div>
          </div>
        </div>
        <div class="grid-cards__fields">
          <div class="grid-cards__fields--item">
            <label class="label" for="card-expiry-date">{{ 'nouns.expiryDate' | translate }}</label>
            <div id="card-expiry-date" class="input"></div>
          </div>
          <div class="grid-cards__fields--item gap">
            <label class="label" for="card-cvc">{{ 'nouns.cvc' | translate }}</label>
            <div id="card-cvc" class="input"></div>
          </div>
        </div>

        <div class="payment-buttons">
          <gl-button
            #payment_submit
            id="payment-submit"
            [text]="
              ('payment.pay' | translate) +
              ' ' +
              (payment.amount | number : '1.2-2' : locale) +
              ' ' +
              payment.currency
            "
            [attr.disabled]="
              !clientMail.invalid &&
              cardValidation.cardNumber &&
              cardValidation.cardExpiry &&
              cardValidation.cardCvc
                ? null
                : true
            "
            (click)="!payment_submit.disabled && handleSubmit()"
            color-primary
            large
          ></gl-button>
        </div>
      </form>
    </div>

    <div *ngIf="!processing" class="payment-card feedback">
      <div class="payment-card__feedback--content">
        <div class="payment-card__icon">
          <span
            class="glicon-check-circle-thin success"
            [ngClass]="{
              'glicon-alert-thin failed': error,
              'glicon-check-circle-thin success': !error
            }"
          ></span>
        </div>
        <div
          class="payment-card__text"
          *ngIf="!error"
          [innerHtml]="'payment.success' | translate"
        ></div>
        <div class="payment-card__text" *ngIf="error" [innerHtml]="error.message"></div>
        <gl-button
          *ngIf="error"
          id="payment-submit"
          [text]="'actions.accept' | translate"
          color-primary
          large
          (click)="reset()"
        >
        </gl-button>
      </div>
    </div>
  </div>
</div>
<app-footer type="payment"></app-footer>
